<template>

    <div class="main-container">
        <bread-crumb :items="breadcrumbPath" />
        <v-divider />
        <v-flex
            md5
            sm6
            v-cloak
            xs12
        >
            <ManageJobsTable />
        </v-flex>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import {FETCH_JOB, FETCH_JOB_LIST,} from "@/store/job/actions.js";
    import ManageJobsTable from '@/views/ManageJobs/components/ManageJobsTable.vue';

    export default {

        components: {
            ManageJobsTable,
        },

        data() {
            return {
                breadcrumbPath: [{text: 'Manage Jobs', to: "manage-jobs"}],
                loading: true,
                personnelWithJobTitle: [],
                selectedPersonnelId: '',
                jobId: '',
                chosenPerson: {},

            };
        },

        computed: {
            ...mapGetters(
            [
                "job",
                "jobList",
                "editStateJob",
            ]
            )
        },

        mounted() {
            this.fetchJobs();

            if (
            this.$route.params !== undefined
            && this.$route.params.jobId !== undefined) {
                this.jobId = this.$route.params.jobId;
            }

            if (this.jobId > 0) {
                this.fetchJob();
            }
        },

        methods: {
            fetchJobs() {
                this.$store.dispatch(FETCH_JOB_LIST);
            },

            fetchJob() {
                this.$store.dispatch(FETCH_JOB, this.jobId);
            },
        },
    }
</script>

<style scoped>
    #jobsTable {
        width: 100%;
        text-align: left;
        padding-left: 16px;
    }
</style>
